var gaEvents = {

	/**
	 * Common DOM selectors
	 */
	customDOMElementsSelector: '[data-ga-event]',
	customDOMgroupedElementsSelector: '[data-ga-event-group]',

	/**
	 * Initialise everything
	 */
	initiliase: function () {

		// this.bootstrapPrimaryNavigationGAEvents();
		this.bootstrapCustomDOMElementsGAEvent();

	},

	/**
	 * Set up GA Events listeners for Custom DOM elements
	 */
	bootstrapCustomDOMElementsGAEvent: function() {

		// window.console.log('Initialising custom DOM elements\' tracking');

		// Select all DOM elements that have a "data-ga-event" data attribute
		var customElements = Array.from(document.querySelectorAll(this.customDOMElementsSelector));

		//window.console.log('Tracking elements', customElements);

		customElements.map(function(customElement) {

			var domEventType = customElement.dataset.gaDomEventType;

			// Determine event type. Defaults to 'click'.
			if (domEventType === undefined) {
				domEventType = 'click';
			}

			// window.console.log('domEventType', domEventType);

			switch (domEventType) {

				// Process events that need to be fired when an element scrolls into view
				case 'scroll-to':
					window.addEventListener( 'scroll', gaEvents.scrollEventHandler.bind(null, customElement ) );
					break;

				case 'change':
					gaEvents.changeEventHandler(customElement);
					break

				// Process events that to be fired
				case 'click':
				default:
					var eventName = customElement.dataset.gaEvent;
					var eventCategory = customElement.dataset.gaEventCategory;
					var eventAction = customElement.dataset.gaEventAction;
					var eventLabel = customElement.dataset.gaEventLabel;
					var eventGroup = customElement.dataset.gaEventGroup;
					var eventConditionSelector = customElement.dataset.gaEventConditionSelector;
					var eventConditionClass = customElement.dataset.gaEventConditionClass;
					var eventConditionNoClass = customElement.dataset.gaEventConditionNoClass;
					var href = customElement.getAttribute('href');

					customElement.addEventListener('click', function (event) {

						// Only process if current DOM element is not marked as its custom event already fired
						if (customElement.getAttribute('data-ga-event-grouped-event-fired') !== '1') {

							var originalURL = window.location.href.split("#")[0];
							var anchor = '';
							if (customElement.href) {
								var splitCustomElementURL = customElement.href.split("#");
								if (splitCustomElementURL.length > 1) {
									anchor = splitCustomElementURL[1];
								}
							}

							// var targetURL = event.target.href.split("#")[0];
							if (customElement.href) {
								var targetURL = customElement.href.split("#")[0];
							} else {
								var targetURL = '';
							}

							var redirect = false;
							if ((targetURL !== '' && originalURL !== targetURL && !customElement.classList.contains('watch_video')) || (originalURL == targetURL && anchor !== '')) {
								redirect = true;
							}

							// Track FAQs open and close events
							if (eventCategory === 'faq panel') {
								if(customElement.getAttribute('aria-expanded') === "false") {
									var eventAction = "close";
								} else {
									var eventAction = "open";
								}
							} else {
								var eventAction = customElement.dataset.gaEventAction;
							}

							if (eventConditionSelector) {

								// Start using a flag that shows if the custom GTM event needs to be fired based on conditions
								var fireCustomEvent = false;

								switch (eventConditionSelector) {

									// Parent element
									case '{parent}':
										// var conditionElement = event.target.parentElement;
										var conditionElement = customElement.parentElement;
										var conditionElementClasses = conditionElement.classList;
										if (eventConditionClass) {
											fireCustomEvent = conditionElementClasses.contains(eventConditionClass)
										} else if (eventConditionNoClass) {
											fireCustomEvent = !conditionElementClasses.contains(eventConditionNoClass)
										}
										break;

									// Self
									case '{self}':
										// var conditionElement = event.target;
										var conditionElement = customElement;
										var conditionElementClasses = conditionElement.classList;
										if (eventConditionClass) {
											fireCustomEvent = conditionElementClasses.contains(eventConditionClass)
										} else if (eventConditionNoClass) {
											fireCustomEvent = !conditionElementClasses.contains(eventConditionNoClass)
										}
										break;

									// All other cases
									default:
										// No support for this yet
										break;
								}

							} else {

								var fireCustomEvent = true;

							}

							if (fireCustomEvent) {
								// gaEvents.triggerCustomElementGAEvent(event.target.href, eventName, eventCategory, eventAction, eventLabel, href, eventGroup, redirect, event.target.getAttribute('target'), customElement);
								gaEvents.triggerCustomElementGAEvent(customElement.href, eventName, eventCategory, eventAction, eventLabel, href, eventGroup, redirect, customElement.getAttribute('target'), customElement);
							}

							event.preventDefault();

						}
					});
			}

			return customElement;

		});

	},

	processGroupedDOMElements: function(groupName) {

		// Find all grouped elements
		// Process an event only of the one that was interacted with
		// Mark all grouped events as fired

		// Select all DOM grouped elements related to GA tracking
		var groupedElements = Array.from(document.querySelectorAll('[data-ga-event-group="' + groupName + '"]'));

		groupedElements.map(function(groupedElement) {
			groupedElement.setAttribute('data-ga-event-grouped-event-fired', '1');
		})

	},

	/**
	 * Process the scroll event
	 *
	 * @param el
	 */
	scrollEventHandler: function(el) {

		// Check if the DOM element is in view
		let isElementInView = gaEvents.isElementInView(el);

		// Only process if the element is in view and the scroll-to event has not fired for it yet
		if (isElementInView && (el.getAttribute('data-ga-event-group')  && el.getAttribute('data-ga-event-grouped-event-fired') !== '1') || (!el.getAttribute('data-ga-event-group'))) {

			var eventName = el.dataset.gaEvent;
			var eventCategory = el.dataset.gaEventCategory;
			var eventAction = el.dataset.gaEventAction;
			var eventLabel = el.dataset.gaEventLabel;
			var pagePath = el.dataset.gaEventPath;
			var eventGroup = el.dataset.gaEventGroup;

			var eventObject = gaEvents.removeEmptyAttributes({
					'event': eventName,
					'eventCategory': eventCategory,
					'eventAction': eventAction,
					'eventLabel': eventLabel,
					'pagePath': pagePath
				}
			);

			if (!window.dataLayer) {
				window.console.log('Pushing custom event (scroll)', eventObject);
			}

			// Set event to GA
			// dataLayer.push(eventObject);

			// console.log('eventCategory', eventCategory);

			if (eventCategory == 'form start') {
				var prospaFlashEvents = JSON.parse(window.sessionStorage.getItem('prospaFlashEvents'));

				if (!prospaFlashEvents) {
					prospaFlashEvents = {};
				}

				if (prospaFlashEvents) {
					if (!('form submit' in prospaFlashEvents)) {
						prospaFlashEvents['form submit'] = [];
					}

					prospaFlashEvents['form submit'] = [
						{
							'event': 'dataLayerEvent',
							'eventCategory': 'form submit',
							'eventAction': 'loan request',
							'eventLabel': eventLabel
						}
					];
				}

				// console.log('prospaFlashEvents', prospaFlashEvents);
				// console.log('Adding prospaFlashEvents to window.sessionStorage', JSON.stringify(prospaFlashEvents));
				window.sessionStorage.setItem('prospaFlashEvents', JSON.stringify(prospaFlashEvents));
			}

			gaEvents.processGroupedDOMElements(eventGroup);
		}

	},

	/**
	 * Process the change event
	 *
	 * @param el
	 */
	changeEventHandler: function(customElement) {

		var eventName = customElement.dataset.gaEvent;
		var eventCategory = customElement.dataset.gaEventCategory;
		var eventAction = customElement.dataset.gaEventAction;
		var eventLabel = customElement.dataset.gaEventLabel;
		var eventGroup = customElement.dataset.gaEventGroup;
		var eventConditionSelector = customElement.dataset.gaEventConditionSelector;
		var eventConditionClass = customElement.dataset.gaEventConditionClass;
		var eventConditionNoClass = customElement.dataset.gaEventConditionNoClass;
		var href = customElement.getAttribute('href');

		customElement.addEventListener('change', function (event) {

			var optionLabel = customElement.value.replaceAll('-', ' ');
			var name = customElement.dataset.dropdownName;
			eventLabel = 'dropdown-name:' + name + '_' + 'selected-option:' + optionLabel;

			// Only process if current DOM element is not marked as its custom event already fired
			if (customElement.getAttribute('data-ga-event-grouped-event-fired') !== '1') {

				var redirect = false;

				if (eventConditionSelector) {

					// Start using a flag that shows if the custom GTM event needs to be fired based on conditions
					var fireCustomEvent = false;

					switch (eventConditionSelector) {

						// Parent element
						case '{parent}':
							// var conditionElement = event.target.parentElement;
							var conditionElement = customElement.parentElement;
							var conditionElementClasses = conditionElement.classList;
							if (eventConditionClass) {
								fireCustomEvent = conditionElementClasses.contains(eventConditionClass)
							} else if (eventConditionNoClass) {
								fireCustomEvent = !conditionElementClasses.contains(eventConditionNoClass)
							}
							break;

						// Self
						case '{self}':
							// var conditionElement = event.target;
							var conditionElement = customElement;
							var conditionElementClasses = conditionElement.classList;
							if (eventConditionClass) {
								fireCustomEvent = conditionElementClasses.contains(eventConditionClass)
							} else if (eventConditionNoClass) {
								fireCustomEvent = !conditionElementClasses.contains(eventConditionNoClass)
							}
							break;

						// All other cases
						default:
							// No support for this yet
							break;
					}

				} else {

					var fireCustomEvent = true;

				}

				if (fireCustomEvent) {
					gaEvents.triggerCustomElementGAEvent(customElement.href, eventName, eventCategory, eventAction, eventLabel, href, eventGroup, redirect, customElement.getAttribute('target'), customElement);
				}

				event.preventDefault();

			}
		});

	},

	/**
	 * Construct the event object for submitting to GA
	 * @param eventAttributes
	 * @returns {*}
	 */
	removeEmptyAttributes: function(eventAttributes) {
		return Object.keys(eventAttributes)
			.filter(function(f) { return !!eventAttributes[f] && eventAttributes[f].length > 0 } )
			.reduce(function(r, i) {r[i] = eventAttributes[i]; return r;} , {});
	},

	/**
	 * Attach events to top level menu items
	 *
	 * @param menuTopLevelItems
	 */
	attachEventsToTopLevelMenuItems: function(menuTopLevelItems) {

		Array.from(menuTopLevelItems).map(function(topLevelMenuItem) {

			var menuItemLink = topLevelMenuItem.querySelector('.menu-item-link');

			if (menuItemLink) {
				menuItemLink.addEventListener('click', function (event) {
					event.preventDefault();
					gaEvents.triggerPrimaryNavigationGAEvent(event.target.href, menuItemLink.text.toLowerCase(), 'index');
				});
			}

			return topLevelMenuItem;

		});

	},

	/**
	 * Attach events to second level menu items
	 *
	 * @param menuSecondLevelItems
	 */
	attachEventsToSecondLevelMenuItems: function(menuSecondLevelItems) {

		Array.from(menuSecondLevelItems).map(function(secondLevelMenuItem) {

			var secondLevelMenuItemLink = secondLevelMenuItem.querySelector('.menu-item-link');
			var parentMenuItem = secondLevelMenuItem.closest('.menu-item.menu-item-has-children');
			var parentMenuItemLink = parentMenuItem.querySelector('.menu-item-link');

			secondLevelMenuItemLink.addEventListener('click', function (event) {
				event.preventDefault();
				gaEvents.triggerPrimaryNavigationGAEvent(event.target.href, parentMenuItemLink.text.toLowerCase(), secondLevelMenuItemLink.text.toLowerCase());
			});

			return secondLevelMenuItem;

		});

	},

	/**
	 * Trigger GA event for the primary navigation items
	 *
	 * @param originalURL
	 * @param action
	 * @param label
	 */
	triggerPrimaryNavigationGAEvent: function(originalURL, action, label) {
		this.triggerCustomElementGAEvent(originalURL, 'dataLayerEvent', 'primary nav interaction', action, label, '', '', true, undefined, undefined);
	},

	/**
	 * Trigger GA Event when a custom DOM element is clicked
	 *
	 * @param originalURL
	 * @param event
	 * @param category
	 * @param action
	 * @param label
	 * @param href
	 * @param groupName
	 * @param redirect
	 * @param target
	 * @param customElement
	 */
	triggerCustomElementGAEvent: function(originalURL, event, category, action, label, href, groupName, redirect, target, customElement) {

		if (customElement === undefined) {
			customElement = null;
		}

		if (target === undefined) {
			target = '_self';
		}

		// Replace old label keys with new ones (shortening them to comply with GA4 lengths limitations)
		label = label.replace('site-position:', 'pos:');
		label = label.replace('digital-lead-source:', 'dls:');
		label = label.replace('partner-id:', 'pid:');

		var payload = {
			'event': event,
			'eventCategory': category,
			'eventAction': action,
			'eventLabel': label
		};

		// Set event to GA and redirect to original URL
		if (window.dataLayer) {
			window.dataLayer.push(payload);
		} else {
			window.console.log('Pushing custom event', payload);
		}

		// console.log('eventCategory', category);

		if (category == 'form start') {
			var prospaFlashEvents = JSON.parse(window.sessionStorage.getItem('prospaFlashEvents'));

			if (!prospaFlashEvents) {
				prospaFlashEvents = {};
			}

			if (prospaFlashEvents) {
				if (!('form submit' in prospaFlashEvents)) {
					prospaFlashEvents['form submit'] = [];
				}

				prospaFlashEvents['form submit'] = [
					{
						'event': 'dataLayerEvent',
						'eventCategory': 'form submit',
						'eventAction': 'loan request',
						'eventLabel': label
					}
				];
			}

			// console.log('prospaFlashEvents', prospaFlashEvents);
			// console.log('Adding prospaFlashEvents to window.sessionStorage', JSON.stringify(prospaFlashEvents));
			window.sessionStorage.setItem('prospaFlashEvents', JSON.stringify(prospaFlashEvents));
		}

		// Check if HREF is an anchor link within current page
		if (redirect && !/^#collapse-/.test(href) && !/^#$/.test(href) && !customElement.classList.contains('watch_video')) {

			// Non-anchor link
			// Just in case GA request failed we still want to redirect - redirecting manually with a 2 seconds delay)
			setTimeout(function() {
				gaEvents.redirectToOriginalURL(originalURL, target)
			}, 100);

		}

		gaEvents.processGroupedDOMElements(groupName);

	},
	/**
	 * Redirect to original URL
	 *
	 * @param originalURL
	 */
	redirectToOriginalURL: function (originalURL, target) {
		if (target) {
			window.open(originalURL, target);
		} else {
			window.location.href = originalURL;
		}
	},

	/**
	 * Check if the provided DOM element is in view
	 *
	 * @param el
	 * @returns {boolean}
	 */
	isElementInView: function(el) {

		var scroll = window.scrollY || window.pageYOffset;
		var boundsTop = el.getBoundingClientRect().top + scroll;

		var viewport = {
			top: scroll,
			bottom: scroll + window.innerHeight,
		};

		var bounds = {
			top: boundsTop,
			bottom: boundsTop + el.clientHeight,
		};

		return ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom ) || ( bounds.top <= viewport.bottom && bounds.top >= viewport.top );
	}

}

document.addEventListener("DOMContentLoaded", function () {
	// Initialise listeners to fire GA Events
	gaEvents.initiliase();
});